import React from 'react'
import { Image } from 'react-bootstrap'
// left top brain assests
import leftBrainTopImg from '../../images/Seeding Brains UI/Leftbrainp3-01.png'
import AGIImg from '../../images/Seeding Brains UI/AGI-01.png'
import AMSImg from '../../images/Seeding Brains UI/AMS-01.png'
import CIIEImg from '../../images/Seeding Brains UI/CIIE-01.png'
// left middle brain assests
import leftBrainMiddleImg from '../../images/Seeding Brains UI/LeftBrainP2-01.png'
import ESLImg from '../../images/Seeding Brains UI/ESL-01.png'
// import IBTImg from '../../images/Seeding Brains UI/IBT-01.png'
import LAATImg from '../../images/Seeding Brains UI/LAAT-01.png'

// left bottom brain assests
import leftBrainBottomImg from '../../images/Seeding Brains UI/leftbrainsP1-01.png'
import TWIImg from '../../images/Seeding Brains UI/TWI-01.png'
import UKCBCImg from '../../images/Seeding Brains UI/UKCBC-01.png'
// import LIIMSImg from '../../images/Seeding Brains UI/LIIMS-01.png'
// import REGENTImg from '../../images/Seeding Brains UI/REGENT-01.png'
import brainRightTitleImg from '../../images/Seeding Brains UI/LOGO17.png'
//css module
import classes from './BrainLeft.module.css'

const BrainLeft = () => {
  return (
    <div style={{ overflow: 'hidden' }}>
      <div className={classes.leftBrainPartContainer}>
        <BrainTop />
      </div>
      <div className={classes.leftBrainPartContainer}>
        <BrainMiddle />
      </div>
      <div className={classes.leftBrainPartContainer}>
        <BrainBottom />
      </div>
    </div>
  )
}

const BrainTop = () => (
  <div className={classes.leftBrainTopImgContainer}>
    <Image src={leftBrainTopImg} className={classes.leftBrainTopImg} alt='' />
    <div
      className={`${classes.leftBrainTopTitle} ${classes.opacity} opacity-left left-brain-top-title`}
    >
      <Image
        src={brainRightTitleImg}
        className={`${classes.imgWidth250}`}
        alt=''
      />
    </div>
    <div
      className={`${classes.positionAbsolute} ${classes.AGIImgContainer} opacity-left AGIImgContainer ${classes.opacity}`}
    >
      <a href='https://agiuae.com/' target='_blank'>
        <Image src={AGIImg} className={classes.imgWidth120} alt='' />
      </a>
    </div>
    <div
      className={`${classes.positionAbsolute} ${classes.CIIEImgContainer} opacity-left CIIEImgContainer ${classes.opacity}`}
    >
      <a href='https://www.centralinstitute.ae/' target='_blank'>
        <Image src={CIIEImg} className={classes.imgWidth120} alt='' />
      </a>
    </div>
    <div
      className={`${classes.positionAbsolute} ${classes.AMSImgContainer} opacity-left AMSImgContainer ${classes.opacity}`}
    >
      <a href='https://academyofmulti-skills.org.uk/' target='_blank'>
        <Image src={AMSImg} className={`${classes.imgWidth120} p-2`} alt='' />
      </a>
    </div>
  </div>
)

const BrainMiddle = () => (
  <div className={classes.leftBrainMidImgContainer}>
    <Image
      src={leftBrainMiddleImg}
      className={classes.leftBrainMidImg}
      alt=''
    />
    <div
      className={`${classes.positionAbsolute} ${classes.ESLImgContainer} opacity-left ESLImgContainer ${classes.opacity}`}
    >
      <a href='https://www.elizabethschool.com/' target='_blank'>
        <Image src={ESLImg} className={`${classes.imgWidth120}`} alt='' />
      </a>
    </div>
    {/* <div
      className={`${classes.positionAbsolute} ${classes.IBTImgContainer} opacity-left IBTImgContainer ${classes.opacity}`}
    >
      <Image
        src={IBTImg}
        className={`${classes.imgWidth120} ${classes.IBTImgSize}`}
        alt=''
      />
    </div> */}
    <div
      className={`${classes.positionAbsolute} ${classes.LAATImgContainer} opacity-left LAATImgContainer ${classes.opacity}`}
    >
      <a href='https://laatedu.com/' target='_blank'>
        <Image
          src={LAATImg}
          className={`${classes.imgWidth120} ${classes.LAATImgSize}`}
          alt=''
        />
      </a>
    </div>
  </div>
)

const BrainBottom = () => (
  <div className={classes.leftBrainBottomImgContainer}>
    <Image
      src={leftBrainBottomImg}
      className={classes.leftBrainBottomImg}
      alt=''
    />
    {/* <div
      className={`${classes.positionAbsolute} ${classes.LIIMSImgContainer} opacity-left LIIMSImgContainer ${classes.opacity}`}
    >
      <Image src={LIIMSImg} className={classes.LIIMSImg} alt='' />
    </div> */}
    <div
      className={`${classes.positionAbsolute} ${classes.TWIImgContainer} opacity-left TWIImgContainer ${classes.opacity}`}
    >
      <a href='https://thewoolwichinstitute.com/' target='_blank'>
        <Image src={TWIImg} className={classes.imgWidth120} alt='' />
      </a>
    </div>
    <div
      className={`${classes.positionAbsolute} ${classes.UKCBCImgContainer} opacity-left UKCBCImgContainer ${classes.opacity}`}
    >
      <a href='https://ukcbc.ac.ae/' target='_blank'>
        <Image
          src={UKCBCImg}
          className={classes.imgWidth120}
          style={{ padding: 4 }}
          alt=''
        />
      </a>
    </div>

    {/* <div
      className={`${classes.positionAbsolute} ${classes.REGENTImgContainer} opacity-left REGENTImgContainer ${classes.opacity}`}
    >
      <Image src={REGENTImg} className={classes.REGENTImg} alt='' />
    </div> */}
  </div>
)

export default BrainLeft
